export enum FORM_MODE {
    ADD = 'add',
    EDIT = 'edit',
    DETAIL = 'detail',
}

export type FormModeType = FORM_MODE.ADD | FORM_MODE.EDIT | FORM_MODE.DETAIL;
